import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Endpoint } from "../shared/endpoints";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserFeedbackService {
  constructor(private http: HttpClient) {}

  sendFeedback(userFeedbackModel: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.sendFeedbackUrl,
      userFeedbackModel,
      { headers }
    );
  }

  getAllFeedback(): Observable<any> {
    return this.http.get<any>(
      environment.apiBaseUrl + Endpoint.getAllFeedbackUrl
    );
  }

  getFeedbackByEmail(userEmail: string): Observable<any> {
    return this.http.get<any>(
      environment.apiBaseUrl + Endpoint.getFeedbackByEmailUrl + `?userEmail=${userEmail}`
    );
  }

  getFeedbackByRowKey(rowKey: string): Observable<any> {
    return this.http.get<any>(
      environment.apiBaseUrl + Endpoint.getFeedbackByRowKeyUrl + `?rowKey=${rowKey}`
    );
  }

  updateFeedback(userFeedbackModel: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.updateFeedbackUrl,
      userFeedbackModel,
      { headers }
    );
  }

  deleteFeedback(userFeedbackModel: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    return this.http.post<any>(
      environment.apiBaseUrl + Endpoint.deleteFeedbackUrl,
      userFeedbackModel,
      { headers }
    );
  }
}

